/**
 * @constant
 */
const UserTypes = {
    SERVICE: "V",
    OWNER: "O",
    USER: "U",
    TRANSLATOR: "T",
    MANAGER: "F",
    SUPPORT: "S",
    SUPPORT_FAKE: "SF",
    TV: "TV"
};

module.exports = UserTypes;
